import { applyMiddleware, combineReducers, createStore } from 'redux';
import thunk from 'redux-thunk';
import { IPackageListingState } from '../classes/package-listing';
import { IPackageListingAppSettings } from '../custom/classes/package-listing-settings';
import { IPackageListingAppText } from '../custom/classes/package-listing-text';
import { IPackage } from '../custom/classes/production';
import { getPackagePerformances } from '../helpers/package-helper';
import { initializeCartWithSessionPerformances, loadPackage, loadPackageRequest, loadPackages, loadPwycSettings, selectPackage, updateGeneralAdmissionIds, updateSettings } from './actions/package-listing.actions';
import packageListingReducer from './reducers/package-listing.reducer';
import packageListingSettingsReducer from './reducers/package-settings.reducer';
import packageListingTextReducer from './reducers/package-text.reducer';


declare const pageData: any;
declare const packageDetail: any;
declare const packages: Array<IPackage>;
declare const packageRequest: any;
declare const generalAdmissionPerfIds: Array<number>;
declare const pwycPerformanceSettings: any;

export interface IPackageListingAppState {
    packageListing: IPackageListingState<IPackage>;
    packageListingText: IPackageListingAppText;
    packageListingSettings: IPackageListingAppSettings;
}

const appReducer = combineReducers({
    packageListing: packageListingReducer,
    packageListingText: packageListingTextReducer,
    packageListingSettings: packageListingSettingsReducer
});

//let calendarSettings = {
//    ...defaultCalendarSettings
//};

const appStore = createStore(appReducer, {
    //calendarSettings: calendarSettings
}, applyMiddleware(thunk));

// redux-thunk messes with redux typings.
//appStore.dispatch(getEventsFromApi() as any);


appStore.dispatch(updateSettings(pageData) as any);
if (typeof (packageDetail) === "undefined") {
    appStore.dispatch(loadPackages(packages));

    var packagesWithPerfs = packages.filter(p => getPackagePerformances(p).length > 0);

    if (packagesWithPerfs.length == 1) {
        var select = selectPackage((packagesWithPerfs[0]));
        appStore.dispatch(select as any);

    }
    if (packageRequest) {
        appStore.dispatch(loadPackageRequest(packageRequest) as any);
    }
} else {
    appStore.dispatch(loadPackage(packageDetail));
}

appStore.dispatch(updateGeneralAdmissionIds(generalAdmissionPerfIds) as any);

// AAC26-75 - Load PWYC settings
if (typeof(pwycPerformanceSettings) !== "undefined" && pwycPerformanceSettings) {
    appStore.dispatch(loadPwycSettings(pwycPerformanceSettings));
}

// Ensure all other state is initialized before handling session performances
Promise.resolve().then(() => {
    if (pageData.sessionPerformances?.length > 0) {
        appStore.dispatch(initializeCartWithSessionPerformances(pageData.sessionPerformances) as any);
    }
});

export { appStore };
